import type { INavigationDrawerContentDestinationProps } from '@sixui/ui';
import { forwardRef } from 'react';
import { faArrowUpRightFromSquare } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { NavigationDrawerContent } from '@sixui/ui';
import stylex from '@stylexjs/stylex';

import { useActiveLink } from '~/hooks/useActiveLink';

export type INavigationDrawerDestinationProps =
  INavigationDrawerContentDestinationProps & {
    children: React.ReactNode;
    href?: string;
    exact?: boolean;
    matchPatterns?: Array<string>;
    dim?: boolean;
  };

const styles = stylex.create({
  trailingIcon: {
    marginLeft: '0.5rem',
  },
});

export const NavigationDrawerDestination = forwardRef(
  function NavigationDrawerDestination(
    props: INavigationDrawerDestinationProps,
    ref?: React.Ref<HTMLButtonElement>,
  ) {
    const { children, href, exact, matchPatterns, ...other } = props;
    const active = useActiveLink({ matchPatterns, href, exact });
    const isExternal = other.target === '_blank';

    return (
      <NavigationDrawerContent.Destination
        active={other.active ?? active}
        href={href}
        ref={ref}
        {...other}
      >
        {children}
        {isExternal ? (
          <FontAwesomeIcon
            {...stylex.props(styles.trailingIcon)}
            icon={faArrowUpRightFromSquare}
            size="xs"
          />
        ) : null}
      </NavigationDrawerContent.Destination>
    );
  },
);
